(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('RefundDialogController', RefundDialogController);

    RefundDialogController.$inject = ['$mdDialog', '$translate', 'Refund', 'AlertService',
        'paymentId', 'stripePayeeEmail', 'maxSubtotal', 'splitRole', 'orderState', 'taxRate',
        'lineItems', 'totalRetailPrice', 'totalAppraiserCost', 'maxVcFee', 'maxAppraiserCost',
        'subTotalTax', 'feeProposed', 'feeProposedTax',
        'alreadyRefundedTotal', 'alreadyRefundedSubtotal', 'alreadyRefundedVcFee',
        'alreadyRefundedAppraiser', 'alreadyRefundedTax'];

    function RefundDialogController($mdDialog, $translate, Refund, AlertService,
        paymentId, stripePayeeEmail, maxSubtotal, splitRole, orderState, taxRate,
        lineItems, totalRetailPrice, totalAppraiserCost, maxVcFee, maxAppraiserCost,
        subTotalTax, feeProposed, feeProposedTax,
        alreadyRefundedTotal, alreadyRefundedSubtotal, alreadyRefundedVcFee,
        alreadyRefundedAppraiser, alreadyRefundedTax) {

        var vm = this;

        vm.paymentId = paymentId;
        vm.stripePayeeEmail = stripePayeeEmail;
        vm.maxSubtotal = maxSubtotal;
        vm.splitRole = splitRole;
        vm.orderState = orderState;
        vm.taxRate = taxRate || 1;
        vm.hasTax = vm.taxRate > 1;

        vm.lineItems = lineItems || [];
        vm.totalRetailPrice = totalRetailPrice;
        vm.totalAppraiserCost = totalAppraiserCost;
        vm.maxVcFee = maxVcFee;
        vm.maxAppraiserCost = maxAppraiserCost;
        vm.subTotalTax = subTotalTax;
        vm.feeProposed = feeProposed;
        vm.feeProposedTax = feeProposedTax;
        vm.vcFee = round2(totalRetailPrice - totalAppraiserCost);

        vm.alreadyRefundedTotal = alreadyRefundedTotal || 0;
        vm.alreadyRefundedSubtotal = alreadyRefundedSubtotal || 0;
        vm.alreadyRefundedVcFee = alreadyRefundedVcFee || 0;
        vm.alreadyRefundedAppraiser = alreadyRefundedAppraiser || 0;
        vm.alreadyRefundedTax = alreadyRefundedTax || 0;
        vm.hasExistingRefunds = vm.alreadyRefundedTotal > 0;

        vm.selectedTab = 0;
        vm.description = '';
        vm.moveToRefundComplete = false;
        vm.isSubmitting = false;
        vm.splitError = null;
        vm.vcFeeError = null;
        vm.appraiserError = null;

        if (vm.hasTax) {
            var taxPercent = Math.round((vm.taxRate - 1) * 100);
            vm.taxLabel = taxPercent + '%';
        }

        vm.fullRefundSubtotal = maxSubtotal;
        vm.fullRefundTax = vm.hasTax ? round2(maxSubtotal * (vm.taxRate - 1)) : 0;
        vm.fullRefundTotal = round2(maxSubtotal + vm.fullRefundTax);

        vm.partialSubtotal = maxSubtotal;
        var initVc = round2(Math.min(vm.vcFee, maxSubtotal, maxVcFee));
        var initAppraiser = round2(maxSubtotal - initVc);
        if (initAppraiser > maxAppraiserCost) {
            initAppraiser = maxAppraiserCost;
            initVc = round2(maxSubtotal - initAppraiser);
        }
        vm.vcFeeRefundAmount = initVc;
        vm.appraiserRefundAmount = initAppraiser;
        vm.partialTax = vm.fullRefundTax;
        vm.partialTotal = vm.fullRefundTotal;

        vm.vcFeeKept = round2(maxVcFee - initVc);
        vm.appraiserKept = round2(maxAppraiserCost - initAppraiser);

        vm.translatedLineItems = [];
        vm.lineItems.forEach(function(item) {
            var key = 'valueconnectApp.EnumProductType.' + item.name;
            $translate(key).then(function(translated) {
                item.translatedName = translated;
            }, function() {
                item.translatedName = item.name;
            });
            vm.translatedLineItems.push(item);
        });

        vm.onSubtotalChange = onSubtotalChange;
        vm.onSplitChange = onSplitChange;
        vm.onKeptChange = onKeptChange;
        vm.submit = submit;
        vm.cancel = cancel;
        vm.isPartialRefundValid = isPartialRefundValid;

        function isBlank(v) {
            return v === null || v === undefined || v === '';
        }

        function toNum(v) {
            if (isBlank(v)) {
                return null;
            }
            var n = Number(v);
            return isNaN(n) ? null : n;
        }

        function onSubtotalChange() {
            var sub = toNum(vm.partialSubtotal);
            if (sub == null || sub < 0.01) {
                vm.partialTax = null;
                vm.partialTotal = null;
                vm.vcFeeRefundAmount = null;
                vm.appraiserRefundAmount = null;
                vm.vcFeeKept = null;
                vm.appraiserKept = null;
                vm.splitError = null;
                vm.vcFeeError = null;
                vm.appraiserError = null;
                return;
            }

            vm.partialTax = vm.hasTax ? round2(sub * (vm.taxRate - 1)) : 0;
            vm.partialTotal = round2(sub + vm.partialTax);

            var proportionalVc = (vm.totalRetailPrice > 0)
                ? round2(sub * (vm.vcFee / vm.totalRetailPrice))
                : round2(sub * 0.5);
            var vc = Math.min(proportionalVc, vm.maxVcFee);
            var appraiser = round2(sub - vc);

            if (appraiser > vm.maxAppraiserCost) {
                appraiser = vm.maxAppraiserCost;
                vc = round2(sub - appraiser);
            }

            vm.vcFeeRefundAmount = round2(vc);
            vm.appraiserRefundAmount = round2(appraiser);
            updateKeptValues();
            validateSplit();
        }

        function onSplitChange(source) {
            var sub = toNum(vm.partialSubtotal);
            if (sub == null || sub < 0.01) {
                return;
            }
            if (source === 'vc') {
                var vc = toNum(vm.vcFeeRefundAmount);
                if (vc == null) {
                    vm.appraiserRefundAmount = null;
                    updateKeptValues();
                    validateSplit();
                    return;
                }
                vm.appraiserRefundAmount = round2(Math.min(sub - vc, vm.maxAppraiserCost));
            } else if (source === 'appraiser') {
                var appraiser = toNum(vm.appraiserRefundAmount);
                if (appraiser == null) {
                    vm.vcFeeRefundAmount = null;
                    updateKeptValues();
                    validateSplit();
                    return;
                }
                vm.vcFeeRefundAmount = round2(Math.min(sub - appraiser, vm.maxVcFee));
            }
            updateKeptValues();
            validateSplit();
        }

        function onKeptChange(source) {
            var sub = toNum(vm.partialSubtotal);
            if (sub == null || sub < 0.01) {
                return;
            }
            if (source === 'vc') {
                var keptVc = toNum(vm.vcFeeKept);
                if (keptVc == null) {
                    vm.vcFeeRefundAmount = null;
                    vm.appraiserRefundAmount = null;
                    updateKeptValues();
                    validateSplit();
                    return;
                }
                vm.vcFeeRefundAmount = round2(vm.maxVcFee - keptVc);
                vm.appraiserRefundAmount = round2(Math.min(sub - vm.vcFeeRefundAmount, vm.maxAppraiserCost));
            } else if (source === 'appraiser') {
                var keptAppraiser = toNum(vm.appraiserKept);
                if (keptAppraiser == null) {
                    vm.vcFeeRefundAmount = null;
                    vm.appraiserRefundAmount = null;
                    updateKeptValues();
                    validateSplit();
                    return;
                }
                vm.appraiserRefundAmount = round2(vm.maxAppraiserCost - keptAppraiser);
                vm.vcFeeRefundAmount = round2(Math.min(sub - vm.appraiserRefundAmount, vm.maxVcFee));
            }
            updateKeptValues();
            validateSplit();
        }

        function updateKeptValues() {
            var vcRef = toNum(vm.vcFeeRefundAmount);
            var apRef = toNum(vm.appraiserRefundAmount);
            if (vcRef == null || apRef == null) {
                vm.vcFeeKept = null;
                vm.appraiserKept = null;
                return;
            }
            vm.vcFeeKept = round2(vm.maxVcFee - vcRef);
            vm.appraiserKept = round2(vm.maxAppraiserCost - apRef);
        }

        function validateSplit() {
            var sub = toNum(vm.partialSubtotal);
            vm.splitError = null;
            vm.vcFeeError = null;
            vm.appraiserError = null;

            if (sub == null || sub < 0.01) {
                return;
            }

            var vc = toNum(vm.vcFeeRefundAmount);
            var appraiser = toNum(vm.appraiserRefundAmount);

            if (vc == null || appraiser == null) {
                return;
            }

            var sum = round2(vc + appraiser);
            var hasFieldError = false;

            if (vc < 0) {
                vm.vcFeeError = 'Cannot be negative';
                hasFieldError = true;
            } else if (vc > vm.maxVcFee) {
                vm.vcFeeError = 'Cannot exceed $' + vm.maxVcFee.toFixed(2);
                hasFieldError = true;
            }

            if (appraiser < 0) {
                vm.appraiserError = 'Cannot be negative';
                hasFieldError = true;
            } else if (appraiser > vm.maxAppraiserCost) {
                vm.appraiserError = 'Cannot exceed $' + vm.maxAppraiserCost.toFixed(2);
                hasFieldError = true;
            }

            if (!hasFieldError && Math.abs(sum - sub) > 0.01) {
                var neededVc = round2(sub - appraiser);
                var neededAppraiser = round2(sub - vc);
                var hints = [];
                if (neededVc >= 0 && neededVc <= vm.maxVcFee) {
                    hints.push('set VC Fee to $' + neededVc.toFixed(2));
                }
                if (neededAppraiser >= 0 && neededAppraiser <= vm.maxAppraiserCost) {
                    hints.push('set Appraiser Cost to $' + neededAppraiser.toFixed(2));
                }
                vm.splitError = 'VC Fee + Appraiser ($' + sum.toFixed(2) + ') must equal subtotal ($' + sub.toFixed(2) + ').';
                if (hints.length > 0) {
                    vm.splitError += ' To fix: ' + hints.join(', or ') + '.';
                }
            }
        }

        function isPartialRefundValid() {
            var sub = toNum(vm.partialSubtotal);
            if (sub == null || sub < 0.01 || sub > vm.maxSubtotal + 0.0001) {
                return false;
            }
            var vc = toNum(vm.vcFeeRefundAmount);
            var appraiser = toNum(vm.appraiserRefundAmount);
            if (vc == null || appraiser == null) {
                return false;
            }
            if (vm.vcFeeError || vm.appraiserError || vm.splitError) {
                return false;
            }
            var sum = round2(vc + appraiser);
            return Math.abs(sum - sub) <= 0.01;
        }

        function submit() {
            if (vm.selectedTab === 1) {
                var sub = toNum(vm.partialSubtotal);
                if (sub == null || sub < 0.01) {
                    AlertService.error('Enter a refund subtotal greater than zero.');
                    return;
                }
                if (sub > vm.maxSubtotal + 0.0001) {
                    AlertService.error('Refund subtotal cannot exceed the remaining refundable amount.');
                    return;
                }
                var vc = toNum(vm.vcFeeRefundAmount);
                var appraiser = toNum(vm.appraiserRefundAmount);
                if (vc == null || appraiser == null) {
                    AlertService.error('Complete the VC fee and appraiser refund split.');
                    return;
                }
                if (Math.abs(round2(vc + appraiser) - sub) > 0.01) {
                    AlertService.error('VC fee and appraiser amounts must add up to the refund subtotal.');
                    return;
                }
            }

            vm.isSubmitting = true;

            var payload = {
                id: vm.paymentId,
                description: vm.description || null,
                moveToRefundComplete: vm.moveToRefundComplete
            };

            if (vm.selectedTab === 0) {
                payload.subtotal = null;
            } else {
                payload.subtotal = toNum(vm.partialSubtotal);
                payload.vcFeeRefundAmount = toNum(vm.vcFeeRefundAmount);
                payload.appraiserRefundAmount = toNum(vm.appraiserRefundAmount);
            }

            Refund.refundPayment(payload, function(result) {
                AlertService.success('Refund processed successfully.');
                $mdDialog.hide(result);
            }, function(error) {
                vm.isSubmitting = false;
                var message = (error.headers && error.headers('X-valueconnectApp-error'))
                    || (error.data && error.data.message)
                    || 'An error occurred while processing the refund.';
                AlertService.error(message);
            });
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function round2(val) {
            return Math.round(val * 100) / 100;
        }
    }
})();
